var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.links.length),function(index){return _c('app-link',{key:index,attrs:{"index":index - 1,"link":_vm.links[index - 1]},on:{"clicked":_vm.openLink}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }